import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List, Map } from 'immutable'
import _get from 'lodash/get'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { get as getConfig } from '../../../config/index'
import { DETAIL_PAGE_STATIC_KEY } from '../../../services/detail/index'
import { getPrimary } from '../../../services/languages/index'
import Row, { STYLES } from '../../Row.v2/index'
import RowV3 from '../../Row.v3/index'
import TileV2GraphQL from '../../Tile.v2/Tile.v2Graphql/index'
import { H5, HEADING_TYPES } from '../../Heading/index'
import { EN } from '../../../services/languages/constants'

const config = getConfig()
const marketplaceActive = !!_get(config, ['features', 'marketplace'])
const rowV3Active = !!_get(config, ['features', 'rowV3'])

function renderItem (item, params) {
  const { index } = params

  return (
    <TileV2GraphQL
      key={index}
      data={item || Map()}
      disablePlaceholder
      index={index}
    />
  )
}

function DetailMarketplaceProductGraphQL (props) {
  const {
    auth,
    detailData,
    userLanguage,
    viewportWidth,
    staticText,
  } = props
  const isMobile = viewportWidth < 1440
  const products = detailData.get('products', List()) || List()
  const featuredContentProducts = detailData.getIn(['featuredContent', 'products'], List()) || List()
  const seriesProducts = detailData.get('seriesProducts', List()) || List()
  // combine all products from the series or episode
  // remove any duplicates so we have unique products
  const combinedProducts = products.concat(featuredContentProducts, seriesProducts)
    .reduce((acc, product) => {
      const contentId = product.get('contentId')

      return acc.some((p) => p.get('contentId') === contentId) ? acc : acc.push(product)
    }, List())

  if (!combinedProducts.size || !marketplaceActive || userLanguage !== EN) {
    return null
  }

  if (isMobile) {
    return (
      <div className="detail-page__content-marketplace--mobile">
        <H5 as={HEADING_TYPES.H6} className="detail-page__content-marketplace-title">
          {staticText.get('relatedMarketplace')}
        </H5>
        <div className="detail-page__content-marketplace-tiles">
          {rowV3Active
            ? <RowV3 style={STYLES.S12345}>
              {combinedProducts.map((item, index) => renderItem(item, { index }))}
            </RowV3>
            : <Row
              createAccessor={() => null}
              items={combinedProducts}
              auth={auth}
              inverted
              disableScale
              style={STYLES.S12345}
            >
              {(item, data, index, hovered) => renderItem(item, data, index, hovered)}
            </Row>
          }
        </div>
      </div>
    )
  }

  return (
    <div className="detail-page__content-marketplace--desktop">
      <H5 as={HEADING_TYPES.H6} className="detail-page__content-marketplace-title">
        {staticText.get('relatedMarketplace')}
      </H5>
      {rowV3Active
        ? <RowV3
          style={STYLES.SINGLE}
          asGrid
          className="detail-page-products"
        >
          {combinedProducts.map((item, index) => renderItem(item, { index }))}
        </RowV3>
        : <Row
          createAccessor={() => null}
          items={combinedProducts}
          auth={auth}
          inverted
          disableScale
          style={STYLES.SINGLE}
          asGrid
          className="detail-page-products"
        >
          {(item, data, index, hovered) => renderItem(item, data, index, hovered)}
        </Row>
      }
    </div>
  )
}

DetailMarketplaceProductGraphQL.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  detailData: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  viewportWidth: PropTypes.number,
}

export default compose(
  connectRedux(
    (state) => {
      const {
        auth,
        app,
        user,
      } = state

      return {
        auth,
        staticText: state.staticText.getIn(['data', DETAIL_PAGE_STATIC_KEY, 'data']),
        viewportWidth: app.getIn(['viewport', 'width'], 0),
        userLanguage: getPrimary(user.getIn(['data', 'language'])),
      }
    },
  ),
)(DetailMarketplaceProductGraphQL)
